// // reducers/cart.js
// import { createSlice } from '@reduxjs/toolkit';

// const cartSlice = createSlice({
//     name: 'cart',
//     initialState: { items: [], totalAmount: 0 }, // Include totalAmount in the initial state

//     reducers: {
//         setIntervalCart: (state, action) => {
//             state.items = action.payload.items;
//             state.totalAmount = action.payload.totalAmount;
//         },

//         // addToCart: (state, action) => {
//         //     const { product_id, quantity } = action.payload;
//         //     const existingItem = state.items.find(item => item.product_id === product_id);
//         //     if (existingItem) {
//         //         existingItem.quantity += quantity;
//         //         existingItem.subTotal = existingItem.product_MSP * existingItem.quantity;
//         //     } else {
//         //         state.items.push({ ...action.payload, subTotal: action.payload.product_MSP * quantity });
//         //     }
//         //     state.totalAmount = state.items.reduce((total, item) => total + item.subTotal, 0);
//         // },

// addToCart: (state, action) => {
//     const { product_id, attribute_value_id, quantity } = action.payload;

//     const existingItem = state.items.find(
//         item =>
//             item.product_id === product_id &&
//             item.attribute_value_id === attribute_value_id
//     );

//     if (existingItem) {
//         existingItem.quantity += quantity;
//         existingItem.subTotal =
//             existingItem.product_MSP * existingItem.quantity;
//     } else {
//         state.items.push({
//             ...action.payload,
//             subTotal: action.payload.product_MSP * quantity
//         });
//     }

//     state.totalAmount = state.items.reduce(
//         (total, item) => total + item.subTotal,
//         0
//     );
// },


        
//         clearCart: (state) => {
//             state.items = [];
//             state.totalAmount = 0;
//         },

//         // updateQuantity: (state, action) => {
//         //     const { product_id, quantity } = action.payload;
//         //     const itemToUpdate = state.items.find(item => item.product_id === product_id);
//         //     if (itemToUpdate) {
//         //         itemToUpdate.quantity = quantity;
//         //         itemToUpdate.subTotal = itemToUpdate.product_MSP * quantity;
//         //     }
//         // },

// updateQuantity: (state, action) => {
//     const { product_id, attribute_value_id, quantity } = action.payload;

//     const itemToUpdate = state.items.find(
//         item =>
//             item.product_id === product_id &&
//             item.attribute_value_id === attribute_value_id
//     );

//     if (itemToUpdate) {
//         itemToUpdate.quantity = quantity;
//         itemToUpdate.subTotal =
//             itemToUpdate.product_MSP * quantity;
//     }

//     state.totalAmount = state.items.reduce(
//         (total, item) => total + item.subTotal,
//         0
//     );
// },


//         // removeFromCart: (state, action) => {
//         //     const index = state.items.findIndex(item => item.product_id === action.payload);
//         //     if (index !== -1) {
//         //         state.items.splice(index, 1);
//         //     }
//         // },


// removeFromCart: (state, action) => {
//     const { product_id, attribute_value_id } = action.payload;

//     state.items = state.items.filter(
//         item =>
//             !(
//                 item.product_id === product_id &&
//                 item.attribute_value_id === attribute_value_id
//             )
//     );

//     state.totalAmount = state.items.reduce(
//         (total, item) => total + item.subTotal,
//         0
//     );
// },

        
//         updateTotalAmount: (state, action) => {
//             state.totalAmount = action.payload;
//         },
//     },
// });

// export const { setIntervalCart, addToCart, removeFromCart, updateQuantity, updateTotalAmount, clearCart } = cartSlice.actions;
// export default cartSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

const getSavedCart = () => {
    try {
        const cart = sessionStorage.getItem('cart');
        return cart ? JSON.parse(cart) : [];
    } catch {
        return [];
    }
};

const initialItems = getSavedCart();

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: Array.isArray(initialItems) ? initialItems : [],
        totalAmount: Array.isArray(initialItems)
            ? initialItems.reduce((total, item) => total + Number(item?.subTotal || 0), 0)
            : 0
    },
    reducers: {
        setIntervalCart: (state, action) => {
            const items = Array.isArray(action.payload?.items) ? action.payload.items : [];
            state.items = items;
            state.totalAmount = Number(action.payload?.totalAmount || 0);
        },

        addToCart: (state, action) => {
            if (!Array.isArray(state.items)) state.items = [];

            const {
                product_id,
                attribute_value_id,
                quantity = 1,
                product_MSP = 0
            } = action.payload || {};

            const qty = Number(quantity) || 1;
            const msp = Number(product_MSP) || 0;

            const existingItem = state.items.find(
                item =>
                    item.product_id === product_id &&
                    item.attribute_value_id === attribute_value_id
            );

            if (existingItem) {
                existingItem.quantity = Number(existingItem.quantity || 0) + qty;
                existingItem.subTotal =
                    Number(existingItem.product_MSP || 0) * existingItem.quantity;
            } else {
                state.items.push({
                    ...action.payload,
                    quantity: qty,
                    product_MSP: msp,
                    subTotal: msp * qty
                });
            }

            state.totalAmount = state.items.reduce(
                (total, item) => total + Number(item?.subTotal || 0),
                0
            );
        },

        clearCart: state => {
            state.items = [];
            state.totalAmount = 0;
            sessionStorage.removeItem('cart');
        },

        updateQuantity: (state, action) => {
            if (!Array.isArray(state.items)) state.items = [];

            const {
                product_id,
                attribute_value_id,
                quantity
            } = action.payload || {};

            const item = state.items.find(
                item =>
                    item.product_id === product_id &&
                    item.attribute_value_id === attribute_value_id
            );

            if (item) {
                const qty = Number(quantity) || 1;
                item.quantity = qty;
                item.subTotal = Number(item.product_MSP || 0) * qty;
            }

            state.totalAmount = state.items.reduce(
                (total, item) => total + Number(item?.subTotal || 0),
                0
            );
        },

        removeFromCart: (state, action) => {
            if (!Array.isArray(state.items)) state.items = [];

            const {
                product_id,
                attribute_value_id
            } = action.payload || {};

            state.items = state.items.filter(
                item =>
                    !(
                        item.product_id === product_id &&
                        item.attribute_value_id === attribute_value_id
                    )
            );

            state.totalAmount = state.items.reduce(
                (total, item) => total + Number(item?.subTotal || 0),
                0
            );
        },

        updateTotalAmount: (state, action) => {
            state.totalAmount = Number(action.payload || 0);
        }
    }
});

export const {
    setIntervalCart,
    addToCart,
    removeFromCart,
    updateQuantity,
    updateTotalAmount,
    clearCart
} = cartSlice.actions;

export default cartSlice.reducer;




// import { createSlice } from '@reduxjs/toolkit';
// const cartSlice = createSlice({
//     name: 'cart',
//     initialState: {
//         items: [],
//         totalAmount: 0
//     },
//     reducers: {
//         setIntervalCart: (state, action) => {
//             const items = Array.isArray(action.payload?.items)
//                 ? action.payload.items
//                 : [];
//             state.items = items;
//             state.totalAmount = Number(action.payload?.totalAmount || 0);
//         },
//         addToCart: (state, action) => {
//             if (!Array.isArray(state.items)) {
//                 state.items = [];
//             }
//             const {
//                 product_id,
//                 attribute_value_id,
//                 quantity = 1,
//                 product_MSP = 0
//             } = action.payload || {};
//             const qty = Number(quantity) || 1;
//             const msp = Number(product_MSP) || 0;
//             const existingItem = state.items.find(
//                 item =>
//                     item.product_id === product_id &&
//                     item.attribute_value_id === attribute_value_id
//             );
//             if (existingItem) {
//                 existingItem.quantity =
//                     Number(existingItem.quantity || 0) + qty;

//                 existingItem.subTotal =
//                     Number(existingItem.product_MSP || 0) *
//                     existingItem.quantity;
//             } else {
//                 state.items.push({
//                     ...action.payload,
//                     quantity: qty,
//                     product_MSP: msp,
//                     subTotal: msp * qty
//                 });
//             }
//             state.totalAmount = state.items.reduce(
//                 (total, item) =>
//                     total + Number(item?.subTotal || 0),
//                 0
//             );
//         },
//         clearCart: (state) => {
//             state.items = [];
//             state.totalAmount = 0;
//         },
//         updateQuantity: (state, action) => {
//             if (!Array.isArray(state.items)) {
//                 state.items = [];
//             }
//             const {
//                 product_id,
//                 attribute_value_id,
//                 quantity
//             } = action.payload || {};
//             const itemToUpdate = state.items.find(
//                 item =>
//                     item.product_id === product_id &&
//                     item.attribute_value_id === attribute_value_id
//             );
//             if (itemToUpdate) {
//                 const qty = Number(quantity) || 1;
//                 itemToUpdate.quantity = qty;
//                 itemToUpdate.subTotal =
//                     Number(itemToUpdate.product_MSP || 0) * qty;
//             }
//             state.totalAmount = state.items.reduce(
//                 (total, item) =>
//                     total + Number(item?.subTotal || 0),
//                 0
//             );
//         },
//         removeFromCart: (state, action) => {
//             if (!Array.isArray(state.items)) {
//                 state.items = [];
//             }
//             const {
//                 product_id,
//                 attribute_value_id
//             } = action.payload || {};
//             state.items = state.items.filter(
//                 item =>
//                     !(
//                         item.product_id === product_id &&
//                         item.attribute_value_id === attribute_value_id
//                     )
//             );
//             state.totalAmount = state.items.reduce(
//                 (total, item) =>
//                     total + Number(item?.subTotal || 0),
//                 0
//             );
//         },
//         updateTotalAmount: (state, action) => {
//             state.totalAmount = Number(action.payload || 0);
//         }
//     }
// });

// export const {
//     setIntervalCart,
//     addToCart,
//     removeFromCart,
//     updateQuantity,
//     updateTotalAmount,
//     clearCart
// } = cartSlice.actions;

// export default cartSlice.reducer;